import { PortalToken } from '../hooks/useGetPortalToken'

export const PORTAL_URL = (token: PortalToken): string =>
  `https://portal.productboard.com/r1foanqndkwabnvuypb9e6xj?token=${token}`

export const PORTAL_IFRAME_HEIGHT: number = 1000
